import React, { useState } from 'react';
import { CloseableModal } from '../../../../../components/CloseableModal';
import { ModalBody } from './ModalBody';

interface PropTypes {
  onSubmit: (succeeded?: boolean) => void;
  onClose: (succeeded?: boolean) => void;
}

export function CreateAPIKeyModal({ onSubmit, onClose }: PropTypes) {
  const [isSaving, setIsSaving] = useState<boolean>(false);

  return (
    <CloseableModal
      className='modal-dialog-centered'
      onClose={onClose}
      isOpen={true}
      size='md'
      closeDisabled={isSaving}
      keyboard={true}
      backdrop={true}
      headerTitle='Generate API Key'
      bodyChildren={
        <ModalBody
          isSaving={isSaving}
          setIsSaving={setIsSaving}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      }
    />
  );
}
